import { Component, input } from '@angular/core';
import { UserProcess, UserProcessStatusType } from '@interfaces';
import { PRETTY_userProcessStatusCodes } from 'src/app/_constants/application';

@Component({
  selector: 'app-user-process-status',
  templateUrl: './user-process-status.component.html',
  styleUrls: ['./user-process-status.component.scss'],
  standalone: false,
})
export class UserProcessStatusComponent {
  public userProcess = input<Partial<UserProcess>>();
  public userProcessStatus = input<UserProcessStatusType>();
  public iconOnly = input<boolean>(false);

  public PRETTY_userProcessStatusCodes = PRETTY_userProcessStatusCodes;
}
